import { Component } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { LayoutService } from 'src/app/service/app.layout.service';
import { TranslateService } from "src/app/service/comon/translate.service";
import {SessionService} from "../../../service/session/SessionService";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageCommonService} from "../../../service/comon/message-common.service";
import {timeout} from "rxjs/operators";
import {AccountService} from "../../../service/account/AccountService";
import { CaptchaController } from '../../common-module/captcha/captcha';
import { ObservableService } from 'src/app/service/comon/observable.service';
import { CONSTANTS } from 'src/app/service/comon/constants';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [`
        :host ::ng-deep .pi-eye,
        :host ::ng-deep .pi-eye-slash {
            transform:scale(1.6);
            margin-right: 1rem;
            color: var(--primary-color) !important;
        }
    `]
})
export class LoginComponent {

    valCheck: string[] = ['remember'];

    password!: string;

    isShowDialogForgotPass:boolean = false;
    isShowDialogCaptcha: boolean = false;
    isExpiredPassword: boolean = false;
    captchaControl: CaptchaController = new CaptchaController();

    loginInfo : any
    formForgot:any;
    forgotInfo: {
        email: string|null,
    };
    constructor(public layoutService: LayoutService,
        public tranService: TranslateService,
        private formBuilder: FormBuilder,
        private sessionService: SessionService,
        private router: Router,
        private route: ActivatedRoute,
        public messageCommonService: MessageCommonService,
        public accountService: AccountService,
        private observableService: ObservableService
    ) { }
        ngOnInit(): void {
            this.loginInfo = {
                email: "",
                password: "",
                rememberMe : true
            }

            this.loginInfo = {
                email: null,
                password: null,
                rememberMe : true
            }

            this.forgotInfo = {
                email: null,
            }
            this.formForgot = this.formBuilder.group(this.forgotInfo);
            let me = this;
            let quickCode = this.route.snapshot.queryParamMap["params"]["quickCode"];
            if(quickCode){
                console.log(quickCode);
                me.messageCommonService.onload();
                me.sessionService.quickLogin(quickCode, (response)=>{
                    me.executeReponseLogin(response);
                }, null, ()=>{
                    me.messageCommonService.offload();
                })
            }
        }

    resetPasswordEmail(forgotInfo : any) : void {
        // console.log("email reset: " + forgotInfo.email)
        if(this.formForgot.invalid) {
            return;
        }

        this.messageCommonService.onload();
        let me = this;
        this.accountService.forgotPasswordInit(forgotInfo.email, (response) => {
            me.messageCommonService.success(me.tranService.translate("global.message.forgotPassSendMailSuccess"));
            this.isShowDialogForgotPass = false;
        }, null, ()=>{
            me.messageCommonService.offload();
        })
    }

    login(loginInfo : any) : void {
        let me = this;
        if(loginInfo.email && loginInfo.password) {
            // this.isShowDialogCaptcha = true;
            // this.captchaControl.reload();
            this.handleLogin();
        }
    }

    handleLogin(){
        let me = this;
        this.messageCommonService.onload();
        let data = {
            username: this.loginInfo.email,
            password: this.loginInfo.password
        }
        this.sessionService.login(data, (response) => {
            me.executeReponseLogin(response);
        }, null, ()=>{
            me.messageCommonService.offload();
        })
        this.isShowDialogCaptcha = false;
    }

    executeReponseLogin(response){
        let me = this;
        let token = response.data;
        //set token to local storage
        localStorage.setItem("token", token)
        me.sessionService.updateToken(token);
        // call api get current
        me.sessionService.current((response) => {
            me.sessionService.setData("userInfo",JSON.stringify(response));
            me.sessionService.userInfo = response;
            if(me.sessionService.userInfo.type == 0){
                me.router.navigate(['/']);
            }else{
                me.router.navigate(['/']);
            }
        });
    }

    showDialogForgotPass() {
        this.isShowDialogForgotPass = true;
        this.formForgot.reset();
    }

    passwordFocus(){

    }

    handleCaptchaResolved(response: string) {
        if (response) {
            this.handleLogin();
        }
    }
}


